module.exports = __webpack_public_path__ + "img/mobile_ben_g.210e22b6.jpg";